import { createReducer, on } from '@ngrx/store';

import { DepotConfigSliceState } from './depot-config.state';
import { fetchAvailableSubscriptionsForDepotCreationSuccess } from './depot.actions';

export const depotConfigReducer = createReducer<DepotConfigSliceState>(
	new DepotConfigSliceState(),
	on(fetchAvailableSubscriptionsForDepotCreationSuccess, (state, action) =>
		state.setAvailableSubscriptions(action.list)
	)
);
